module.exports = __webpack_public_path__ + "static/media/process.90bb2bf2.jpg";